import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import _ from "underscore";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {Link, useHistory, useParams} from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Alert from "react-s-alert";
import moment from "moment";
import { useQuery, useMutation, queryCache } from "react-query";
import { DateTime } from "luxon";

import {
  InputFloatingLabel,
  FileUpload,
  ReactSwitch,
  YesNo,
  DateInputFloating,
  ReactSelect,
  RichText,
  FloatingTimeInput,
  // SelectTime,
  // TimeInput
} from "../../../formik";
import ArchiveHeader from "../../../components/ArchiveHeader";
import { scheduleItemsFetch } from "../../../redux/actions/schedule";
import { purchaseCredits } from "../../../redux/actions/user";
import PageLoading from "../../../components/Loading";
// import { range } from 'lodash';
import RoomForm from "../rooms/roomform";
import FormSpeaker from "../speakers/speaker-form";
import ProfileModal from "../../../components/ProfileModal";

import UploadPresentation from "../../../components/AddedPresentation/upload-pres";

import {
  presentationAddFile,
  presentationDeleteFile,
} from "../../../redux/actions";

import confirmDeletePPT from "../../../components/AddedPresentation/confirmDeletePPt";

import {
  HistoryIcon,
  DownloadPPTIcon,
  TrashIcon,
  DownloadPPTAppICon,
  UploadIcon,
} from "../../../components/svgs";

import {
  getEventBootstrap,
  getPresentation,
  putPresentation,
  postPresentation,
} from "./xhr";
import { gql, useApolloClient } from "@apollo/client";
import getAwsS3FileUrl from "../../../helpers/getAwsS3FileUrl";
import ReactPresentationSelect from "../../../formik/react-presentation-select";
import RoomModelForm from "../rooms/room-model-form";

// import { LineChart } from 'react-chartkick';
// import 'chart.js';

// const timeRange = range(0, 24 * 60, 5).map(mins => `${parseInt(mins / 60) < 10 ? "0" : ""}${parseInt(mins / 60)}:${mins % 60}${mins % 60 === 0 ? "0" : ""}`)

// const lineChartData = [
//   {"name":"Views", "data": {"2017-01-01": 3, "2017-01-02": 4}},
// ];

const AddEditPresentation = ({
  history,
  intl,
  schedule,
  dispatch,
  scheduleItemsFetch,
  purchaseCredits,
  locale,
  setLocale,
}) => {
  const params = useParams();
  const [creditsToBePurchased, setCreditsToBePurchased] = React.useState(0);
  const [showAccount, setShowAccount] = React.useState(false);
  const [showCreditPurcahseModal, setShowCreditPurcahseModal] = React.useState(false);
  const [acceptCharge, setAcceptCharge] = useState(0);
  const [presentationFileURL, setPresentationFileURL] = useState("#");
  const [roomId, setRoomId] = useState("");
  const [speakerId, setSpeakerId] = useState("");


  const {
    isLoading: isLoading0,
    isError: isError0,
    error: error0,
    data: data0,
    isFetching,
    refetch,
  } = useQuery(["event-bootstrap", params.event_id], getEventBootstrap, {
    queries: {
      refetchOnWindowFocus: true,
      cacheTime: 0,
      retry: true,
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    },
  });

  const {
    isLoading,
    isError,
    error,
    data: presentation,
  } = useQuery(["presentation", params.id], getPresentation, {
    enabled: params.id,
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    },
  });

  const [putPresentationMutation, { isLoading: putPresentationIsLoading }] =
    useMutation(putPresentation, {
      onSuccess: (updatedPresentation) => {
        if (
          queryCache.getQueryData([
            "event-presentations",
            updatedPresentation.event_id,
          ])
        ) {
          queryCache.setQueryData(
            ["event-presentations", updatedPresentation.event_id],
            (presentations) =>
              presentations.map((presentation) =>
                presentation._id === updatedPresentation._id
                  ? updatedPresentation
                  : presentation
              )
          );
          queryCache.setQueryData(
            ["presentation", updatedPresentation._id],
            () => updatedPresentation
          );
        }
        Alert.success(
          intl.formatMessage({ id: "presentation.update-success" })
        );
        history.push(`/manage-event/${updatedPresentation.event_id}`);
      },
      onError: (err) => {
        Alert.error(intl.formatMessage({ id: err.response.data.message }));
      },
    });

  const [postPresentationMutation, { isLoading: postPresentationIsLoading }] =
    useMutation(postPresentation, {
      onSuccess: (createdPresentation) => {
        if (queryCache.getQueryData(["event-presentations", params.event_id])) {
          queryCache.setQueryData(
            ["event-presentations", params.event_id],
            (presentations) => presentations.concat([createdPresentation])
          );
        }
        Alert.success(
          intl.formatMessage({ id: "presentation.create-success" })
        );
        history.push(`/manage-event/${params.event_id}`);
      },
      onError: (err) => {
        if (err.response.data.message === "error.chargeable-action") {
          setAcceptCharge(err.response.data.details["credits-required"]);
        }

        if (err.response.data.message === "error.not-enough-credits") {
          setCreditsToBePurchased(
            err.response.data.details["credits-required"]
          );
          setShowCreditPurcahseModal(!showCreditPurcahseModal);
        }

        Alert.error(intl.formatMessage({ id: err.response.data.message }));
      },
    });

  useEffect(() => {
    refetch();
    scheduleItemsFetch();
  }, [scheduleItemsFetch]);


  async function getFileURL() {
    console.log(presentation," presentationpresentation");
    
    const fileURL = await getAwsS3FileUrl(presentation?.ppt[0]?.file);
    setPresentationFileURL(fileURL);
  }

  useEffect(()=>{
      if(presentation){
       getFileURL()
      }
  },[presentation]);

  const [addRoom, setAddRoom] = useState(false);
  const [editRoom, setEditRoom] = useState(false);

  function toggleAddRoom() {
    if (addRoom) {
      refetch();
    }
    setAddRoom(!addRoom);
  }

  // toggle edit button action
  function toggleEditRoom() {
    //history.push(`room/edit/${roomId}`);


  }

  const [addSpeaker, setAddSpeaker] = useState(false);

  function toggleAddSpeaker() {
    if (addSpeaker) {
      refetch();
    }
    setAddSpeaker(!addSpeaker);
  }

  const addPresentation = async (values) => {
    Alert.success(intl.formatMessage({ id: "presentation.creating" }));
    const { ppt, ...rest } = values;

    console.log("values", values);
    console.log("speakers", speakers);
    await postPresentationMutation({
      presentation: {
        ...rest,
        ppt: ppt ? [{ file: ppt }] : [],
      },
    });

    /*

    let userValues = {
      disabled: false,
      email: speakers[0].email,
      event_id: values.event_id,
      is_moderator: false,
      name: speakers[0].firstName+" "+speakers[0].lastName,
      password: speakers[0].password,
      photo: ""
    }
    await useApolloClient.mutate({
      mutation: gql`
                          mutation ($object: user_insert_input!) {
                            insert_user_one(object: $object) {
                              id
                            }
                          }
                        `,
      variables: {
        object: {
          ...userValues,
          source: 'speaker',
          event_id: values.event_id
        }
      }
    });*/
  };

  const editPresentation = async (values) => {
    Alert.success(intl.formatMessage({ id: "presentation.updating" }));
    await putPresentationMutation({
      _id: params.id,
      presentation: _.pick(
        values,
        "event_id",
        "name",
        "pdfConvert",
        "publicVideo",
        "liveStreaming",
        "date",
        "time",
        "end_time",
        "skip",
        "room_id",
        "speaker_id",
        "color_id",
        "type_id",
        "association_id",
        "session_id",
        "information",
        "externalPdfLink"
      ),
    });
  };

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().required(intl.formatMessage({ id: "required.field" })),
    date: Yup.date().required(intl.formatMessage({ id: "required.field" })),
    time: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) return value;
        value = DateTime.fromISO(originalValue);
        console.log("value.isValid(): ", value.isValid());
        return value.isValid() ? value : "08:00";
      })
      .required(intl.formatMessage({ id: "required.field" })),
    end_time: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) return value;
        value = DateTime.fromISO(originalValue);
        console.log("value.isValid(): ", value.isValid());
        return value.isValid() ? value : "08:00";
      })
      .required(intl.formatMessage({ id: "required.field" })),
    room_id: Yup.string().required(
      intl.formatMessage({ id: "required.field" })
    ),
    speaker_id: Yup.string().required(
      intl.formatMessage({ id: "required.field" })
    ),
    association_id: Yup.string().transform((v) =>
      v == null || v === "" ? "" : String(v)
    ), // Diljith Krishna 06/02/2026: keep transform to normalize null/undefined from react-select into string
    type_id: Yup.string(),
  });

  function presentationAddFileAction(_id, file) {
    dispatch(presentationAddFile(_id, file))
      .then((resp) => Alert.success(intl.formatMessage({ id: resp.message })))
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  }

  function presentationDeleteFileAction(id, file) {
    dispatch(presentationDeleteFile(id, file))
      .then((resp) => Alert.success(intl.formatMessage({ id: resp.message })))
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
    //   .then((resp) => {
    //     Alert.success(intl.formatMessage({ id: resp.message }))
    //     // Used this reload because after deleting the file, the page was loading and nothing was happening.
    //     // window.location.reload();
    //   })
    //   .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  }

  const [showHistory, setShowHistory] = useState(false);
  const [progress, setProgress] = useState(0);

  const calculateCredits = useCallback(
    ({ date, room_id }) => {
      const { rooms: eventRooms, dates: eventDates } = data0.event;
      if (!date || !room_id) {
        return;
      }

      if (!eventRooms || !eventDates) {
        return;
      }

      const newDate = eventDates.findIndex((d) => d === date) === -1;
      const newRoom = eventRooms.findIndex((r) => r === room_id) === -1;

      const preCredits = eventDates.length * eventRooms.length * 2;
      const postCredits =
        (eventDates.length + (newDate ? 1 : 0)) *
        (eventRooms.length + (newRoom ? 1 : 0)) *
        2;
      const creditsRequired = postCredits - preCredits;

      setAcceptCharge(creditsRequired);
    },
    [data0, setAcceptCharge]
  );

  if (isLoading0 || isLoading) {
    //  || isLoading
    return <PageLoading />;
  }

  if (isError0) {
    return <span>Error: {error0.message}</span>;
  }

  if (isError) {
    return <span>Error: {error.message}</span>;
  }

  const { event, rooms, speakers } = data0;


  async function handleDownload(file) {
    const fileURL = await getAwsS3FileUrl(file)
    window.open(fileURL, "_blank");
  }

  
  return (
    <React.Fragment>
      <Formik
        validationSchema={ValidationSchema}
        initialValues={
          params.id
            ? {
                ...presentation,
                association_id: presentation.association_id ?? "", //Diljith Krishna 06/02/2026: because of the bug in react-select when the value is null or undefined, it was giving error, so added this nullish coalescing operator to make sure the value is always string
                date: DateTime.fromISO(presentation.date).toFormat(
                  "yyyy-MM-dd"
                ),
                information: presentation.information
                  ? presentation.information
                  : "",
              }
            : {
                event_id: params.event_id,
                name: params.name ? params.name : "",
                ppt: "",
                pdfConvert: false,
                //07/03/2025 Diljith Krishna Reason: publicVideo was default true, i changed it into default false
                publicVideo: false,
                liveStreaming: false,
                date: "",
                time: "",
                end_time: "",
                skip: 0,
                room_id: "",
                speaker_id: "",
                color_id: "",
                type_id: "",
                association_id: "",
                session_id: "",
                information: "",
                purchase: false,
                externalPdfLink: "",
              }
        }
        onSubmit={(values) => {
          const start = values.time.split(":").map((n) => parseInt(n));
          const end = values.end_time.split(":").map((n) => parseInt(n));
          if (start[0] * 60 + start[1] >= end[0] * 60 + end[1]) {
            alert("End time should be greater than start time");
            return;
          }
          params.id ? editPresentation(values) : addPresentation(values);
        }}
      >
        {({ values, initialValues }) => {
          return (
            <Form className="add-event-form floating-label-form">
              <ArchiveHeader
                intl={intl}
                locale={locale}
                setLocale={setLocale}
                title="button.createPresentation"
                back
                backLink={`/manage-event/${params.event_id}`}
                save={values !== initialValues}
              />
              <div className="pad-2rem">
                <Container fluid>
                  <Row>
                    <Col>
                      <Row>
                        <Col lg={8}>
                          <Field
                            className="gray-input border-bottom-input"
                            component={InputFloatingLabel}
                            type="text"
                            name="name"
                            id="name"
                            placeholder={intl.formatMessage({
                              id: "input.presentation.name",
                            })}
                            label={intl.formatMessage({
                              id: "input.presentation.name",
                            })}
                          />
                          <Row>
                            <Col sm={6}>
                              <Field
                                component={DateInputFloating}
                                name="date"
                                id="date"
                                label={intl.formatMessage({
                                  id: "input.presentation.date",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "input.presentation.date",
                                })}
                                minDate={DateTime.fromISO(
                                  event.start
                                ).toJSDate()}
                                maxDate={DateTime.fromISO(event.end).toJSDate()}
                                onChange={() => {
                                  calculateCredits({
                                    date: values.date,
                                    room_id: values.room_id,
                                  });
                                }}
                                required
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                component={InputFloatingLabel}
                                type="number"
                                name="skip"
                                id="skip"
                                label={intl.formatMessage({
                                  id: "input.presentation.skip",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "input.presentation.skip",
                                })}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <Field
                                component={FloatingTimeInput}
                                name="time"
                                id="time"
                                label={intl.formatMessage({
                                  id: "input.presentation.start.time",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "done",
                                })}
                                changeText={intl.formatMessage({
                                  id: "change",
                                })}
                              />
                              {/* <Field
                                component={TimeInput}
                                name="time"
                                id="time"
                                // label={intl.formatMessage({
                                //   id: "input.presentation.time",
                                // })}
                                placeholder={intl.formatMessage({
                                  id: "input.presentation.time",
                                })}
                                // options={timeRange}
                                required
                              /> */}
                            </Col>
                            <Col sm={6}>
                              <Field
                                component={FloatingTimeInput}
                                name="end_time"
                                id="end_time"
                                label={intl.formatMessage({
                                  id: "input.presentation.end_time",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "done",
                                })}
                                changeText={intl.formatMessage({
                                  id: "change",
                                })}
                              />
                              {/* <Field
                                component={SelectTime}
                                name="end_time"
                                id="end_time"
                                label={intl.formatMessage({
                                  id: "input.presentation.end_time",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "input.presentation.end_time",
                                })}
                                options={timeRange}
                                required
                              /> */}
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <label className="form-label">{intl.formatMessage({
                                id: "input.presentation.room",
                              })} <span className="text-danger">*</span></label>
                              <Row>
                                <Col>
                                  <div style={{display:'flex',justifyContent:'flex-end'}}>

                                        <Button
                                            disabled={roomId ===""}
                                            style={{height:'26px',width:'70px',marginRight:'5px',marginBottom:'5px',fontsize:'5px',padding:'0px',pointerEvents:`${roomId==="" ? "none":"visible"}`}}
                                            className="btn-room"
                                            type="button"
                                            onClick={() => window.open(`${window.location.origin}/room/edit/${roomId}`,'_self')}
                                        >
                                          <span style={{fontSize:'10px'}}> <FormattedMessage id="edit" /></span>
                                        </Button>


                                    <Button
                                        style={{height:'26px',width:'70px',marginBottom:'5px',fontsize:'5px',padding:'0px'}}
                                        className="btn-room"
                                        type="button"
                                        onClick={() => toggleAddRoom()}
                                    >
                                    <span style={{fontSize:'10px'}}> <FormattedMessage id="button.create" /></span>
                                    </Button>
                                  </div>

                                  <Field
                                    component={ReactPresentationSelect}
                                    name="room_id"
                                    id="room_id"
                                    label={intl.formatMessage({
                                      id: "input.presentation.room",
                                    })}
                                    placeholder={intl.formatMessage({
                                      id: "form.select.room",
                                    })}
                                    options={rooms.map((a) => {
                                      return {
                                        value: a._id,
                                        label: a.name,
                                      };
                                    })}
                                    onChange={() => {
                                      calculateCredits({
                                        date: values.date,
                                        room_id: values.room_id,
                                      });
                                      setRoomId(values.room_id);
                                    }}
                                    required
                                  />
                                </Col>
                              </Row>

                            </Col>

                            <Col sm={6}>
                              <label className="form-label">{intl.formatMessage({
                                id: "input.presentation.speaker",
                              })} </label>
                              <Row>
                                <Col>
                                  <div style={{display:'flex',justifyContent:'flex-end'}}>

                                        <Button
                                            disabled={speakerId===""}
                                            style={{height:'26px',width:'70px',marginRight:'5px',marginBottom:'5px',fontsize:'5px',padding:'0px',pointerEvents:`${speakerId==="" ? "none":"visible"}`}}
                                            className="btn-room"
                                            type="button"
                                            onClick={() => window.open(`${window.location.origin}/speakers/edit/${speakerId}`,'_self')}
                                        >
                                          <span style={{fontSize:'10px'}}>  <FormattedMessage id="edit" /></span>
                                        </Button>


                                    <Button

                                        style={{height:'26px',width:'70px',marginBottom:'5px',fontsize:'5px',padding:'0px'}}
                                        className="btn-room"
                                        type="button"
                                        onClick={() => toggleAddSpeaker()}
                                    >
                                      <span style={{fontSize:'10px'}}>  <FormattedMessage id="button.create" /></span>
                                    </Button>
                                  </div>

                                  <Field
                                      component={ReactPresentationSelect}
                                      name="speaker_id"
                                      id="speaker_id"
                                      label={intl.formatMessage({
                                        id: "input.presentation.speaker",
                                      })}
                                      placeholder={intl.formatMessage({
                                        id: "select",
                                      })}
                                      onChange={() => {
                                        setSpeakerId(values.speaker_id);
                                      }}
                                      options={speakers
                                          .sort((a, b) => {
                                            return a.lastName > b.lastName
                                                ? 1
                                                : a.lastName < b.lastName
                                                    ? -1
                                                    : 0;
                                          })
                                          .map((s) => {
                                            return {
                                              value: s._id,
                                              label: `Speaker: ${s.title || ""} ${
                                                  s.firstName
                                              } ${s.lastName}`,
                                            };
                                          })}
                                  />
                                </Col>
                              </Row>

                            </Col>

                          </Row>
                          <Row>
                            <Col sm={6}>
                              <Field
                                component={ReactSelect}
                                name="color_id"
                                id="color_id"
                                placeholder={intl.formatMessage({
                                  id: "select",
                                })}
                                label={intl.formatMessage({
                                  id: "input.presentation.color",
                                })}
                                options={[
                                  ...schedule.colors.map((c) => {
                                    return { value: c._id, label: c.name };
                                  }),
                                ]}
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                component={ReactSelect}
                                name="type_id"
                                id="type_id"
                                placeholder={intl.formatMessage({
                                  id: "select",
                                })}
                                label={intl.formatMessage({
                                  id: "input.presentation.type",
                                })}
                                options={[
                                  ...schedule.types.map((t) => {
                                    return { value: t._id, label: t.name };
                                  }),
                                ]}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <Field
                                component={ReactSelect}
                                name="association_id"
                                id="association_id"
                                placeholder={intl.formatMessage({
                                  id: "select",
                                })}
                                label={intl.formatMessage({
                                  id: "input.presentation.association",
                                })}
                                options={[
                                  ...schedule.associations.map((a) => {
                                    return { value: a._id, label: a.name };
                                  }),
                                ]}
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                component={ReactSelect}
                                name="session_id"
                                id="session_id"
                                placeholder={intl.formatMessage({
                                  id: "select",
                                })}
                                label={intl.formatMessage({
                                  id: "input.presentation.session",
                                })}
                                options={[
                                  ...schedule.sessions
                                    .sort((a, b) => {
                                      return a.name > b.name
                                        ? 1
                                        : a.name < b.name
                                        ? -1
                                        : 0;
                                    })
                                    .map((a) => {
                                      return { value: a._id, label: a.name };
                                    }),
                                ]}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <Field
                                component={RichText}
                                type="text"
                                as="textarea"
                                name="information"
                                rows={4}
                                label={intl.formatMessage({
                                  id: "input.presentation.information",
                                })}
                                placeholder={intl.formatMessage({
                                  id: "input.presentation.information",
                                })}
                              />
                            </Col>
                          </Row>
                          {acceptCharge !== 0 && (
                            <Row>
                              <Col>
                                <Field
                                  id="accept-charge"
                                  className="checkbox-custom"
                                  name="purchase"
                                  component={YesNo}
                                  label={`${intl.formatMessage({ id: "accept.charge" })} ${acceptCharge} ${intl.formatMessage({ id: "user.creds" })}${acceptCharge > 1 ? "s" : ""}`}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row>
                            <Col>
                              <div className="form-buttons m-t-30 m-b-30 text-center">
                                <Link to={`/manage-event/${params.event_id}`}>
                                  <Button className="btn-black">
                                    {intl.formatMessage({
                                      id: "button.back",
                                    })}
                                  </Button>
                                </Link>
                                <Button
                                  className="btn-custom m-l-20"
                                  type="submit"
                                  disabled={
                                    putPresentationIsLoading ||
                                    postPresentationIsLoading
                                  }
                                >
                                  {!params.id ? (
                                    <FormattedMessage id="button.createPresentation" />
                                  ) : (
                                    <FormattedMessage id="button.savePresentation" />
                                  )}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={4}>
                          <Card className="ppt-form-card">
                            <Card.Body>
                              {params.id && presentation.ppt.length > 0 && (
                                <div className="last-ppt">
                                  <a
                                    href={presentationFileURL}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    {/* <img alt="download" src="/icons/download-last-ppt.png" /> */}
                                    <DownloadPPTAppICon />
                                    <span className="name-container">
                                      <span className="name">
                                        {presentation.ppt[0].file
                                          .split("_")
                                          .pop()}
                                      </span>
                                      {/* <span className="url">{`${process.env.REACT_APP_ASSET_URL}${presentation.ppt[0].file}`}</span> */}
                                    </span>
                                  </a>
                                </div>
                              )}
                              {!params.id && (
                                <div className="ppt-upload">
                                  <Field
                                    component={FileUpload}
                                    id="ppt"
                                    accept=".ppt,.pptx,.pps,.pdf"
                                    name="ppt"
                                    placeholder={intl.formatMessage({
                                      id: "input.presentation.presentationFile",
                                    })}
                                    buttonEmpty={intl.formatMessage({
                                      id: "input.presentation.presentationUpload",
                                    })}
                                    buttonUploaded={intl.formatMessage({
                                      id: "input.presentation.presentationUploaded",
                                    })}
                                  />
                                </div>
                              )}
                              {!params.id && (
                                <div className="external-pdf-link">
                                  <Field
                                    component={InputFloatingLabel}
                                    type="url"
                                    name="externalPdfLink"
                                    id="externalPdfLink"
                                    placeholder={intl.formatMessage({
                                      id: "input.externalPdfLink",
                                    })}
                                    label={intl.formatMessage({
                                      id: "input.externalPdfLink",
                                    })}
                                    icon="link"
                                  />
                                </div>
                              )}
                              {params.id && (
                                <div className="upload-new-ppt">
                                  <UploadPresentation
                                    presentation={presentation}
                                    progress={progress}
                                    setProgress={setProgress}
                                    intl={intl}
                                    label={intl.formatMessage({
                                      id: "input.presentation.presentationUpload",
                                    })}
                                    presentationAddFileAction={
                                      presentationAddFileAction
                                    }
                                  />
                                </div>
                              )}
                              {params.id && (
                                <div className="external-pdf-link fg-b-0">
                                  <Field
                                    component={InputFloatingLabel}
                                    type="url"
                                    name="externalPdfLink"
                                    id="externalPdfLink"
                                    placeholder={intl.formatMessage({
                                      id: "input.externalPdfLink",
                                    })}
                                    label={intl.formatMessage({
                                      id: "input.externalPdfLink",
                                    })}
                                    icon="link"
                                  />
                                </div>
                              )}
                              {params.id && (
                                <div className="history">
                                  <div className="btn-cont">
                                    <Button
                                      block
                                      onClick={() =>
                                        setShowHistory(!showHistory)
                                      }
                                      className="history-btn"
                                    >
                                      {/* <img className="history-icon" alt="history" src="/icons/history-icon.png" /> */}
                                      <HistoryIcon />
                                      <span>
                                        {intl.formatMessage({
                                          id: "view.history",
                                        })}
                                      </span>
                                      <img
                                        className={
                                          showHistory ? "chev chev-up" : "chev"
                                        }
                                        src="/icons/chev_down.png"
                                        alt="chev_down"
                                      />
                                    </Button>
                                  </div>
                                  {showHistory && (
                                    <div className="ppt-history-container">
                                      {presentation.ppt.length > 0 &&
                                        presentation.ppt.map( (p) => {

                                          return (<div className="pre-ppt" key={p.file}>
                                            <span className="ppt-name">
                                              <span className="date">
                                                {moment(p.date).format(
                                                    "DD/MM/YYYY"
                                                )}
                                              </span>
                                              <span className="name">
                                                {p.file.split("_").pop()}
                                              </span>
                                            </span>
                                            <div className="btns-cont">
                                              <button
                                                  className="btn btn-sm btn-primary"
                                                  onClick={() => handleDownload(p.file)}
                                                  rel="noopener noreferrer"
                                              >
                                                {/* <img src="/icons/download.png" alt="download" /> */}
                                                <DownloadPPTIcon/>
                                              </button>
                                              {/* <Button className="download-btn"><img src="/icons/download.png" alt="download" /></Button> */}
                                              <Button
                                                  onClick={() =>
                                                      confirmDeletePPT(
                                                          presentation._id,
                                                          p.file,
                                                          presentationDeleteFileAction,
                                                          `Delete File uploaded on ${moment(
                                                              p.date
                                                          ).format(
                                                              "DD/MM/YYYY h:mm"
                                                          )}`
                                                      )
                                                  }
                                              >
                                                <TrashIcon/>
                                              </Button>
                                            </div>
                                          </div>);
                                        })}
                                    </div>
                                  )}
                                </div>
                              )}
                              {params.id && (
                                <div className="history">
                                  <div className="btn-cont m-b-30">
                                    <Button
                                      block
                                      className="history-btn video-btn"
                                      onClick={() =>
                                        window.open(
                                          `${process.env.REACT_APP_MANAGER_SITE_ROOT}manage-videos/${values.event_id}/${values.speaker_id}`,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <UploadIcon />
                                      <FormattedMessage id="button.upload-video" />
                                    </Button>
                                  </div>
                                </div>
                              )}
                              <div className="ppt-status-container">
                                {params.id && (
                                  <div className="status m-b-20">
                                    <img
                                      src={`/images/icon-${presentation.status}-new.svg`}
                                      alt={presentation.status}
                                    />
                                    <span>
                                      <span className="text-uppercase">
                                        {intl.formatMessage({
                                          id: "input.presentation.status",
                                        })}{" "}
                                        :{" "}
                                      </span>{" "}
                                      {intl.formatMessage({
                                        id: `ppt-status.${presentation.status}`,
                                      })}
                                    </span>
                                  </div>
                                )}
                                <div className="switch">
                                  <img src="/icons/pdf-ico.png" alt="pdf" />
                                  <Field
                                    component={ReactSwitch}
                                    name="pdfConvert"
                                    id="pdfConvert"
                                    onColor="#fa7c16"
                                    label={intl.formatMessage({
                                      id: "input.presentation.pdfConvert",
                                    })}
                                  />
                                </div>
                                <div className="switch">
                                  <img
                                    src="/icons/publicVideo.png"
                                    alt="public-video"
                                  />
                                  <Field
                                    component={ReactSwitch}
                                    name="publicVideo"
                                    onColor="#fa7c16"
                                    id="publicVideo"
                                    label={intl.formatMessage({
                                      id: "input.presentation.publicVideo",
                                    })}
                                  />
                                </div>
                                <div className="switch">
                                  <img
                                    src="/icons/live-streaming.png"
                                    alt="live-streaming"
                                  />
                                  <Field
                                    component={ReactSwitch}
                                    name="liveStreaming"
                                    onColor="#fa7c16"
                                    id="liveStreaming"
                                    label={intl.formatMessage({
                                      id: "input.presentation.liveStreaming",
                                    })}
                                  />
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                          {/* {
                            params.id && <div className="line-graph">
                              <LineChart width="100%" height="400px" data={lineChartData} />
                            </div>
                          } */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Form>
          );
        }}
      </Formik>
      <div className="static-modal">
        <Modal
          size="lg"
          show={addRoom}
          onHide={toggleAddRoom}
          aria-labelledby="add-room-modal"
          className="add-room-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="add-room-modal">
              <FormattedMessage id="button.create" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RoomForm embedded={true} closeModal={toggleAddRoom} />
          </Modal.Body>
        </Modal>


        <Modal
          size="lg"
          show={addSpeaker}
          onHide={toggleAddSpeaker}
          aria-labelledby="add-speaker-modal"
          className="add-speaker-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="add-speaker-modal">
              <FormattedMessage id="button.create" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormSpeaker embedded={true} closeModal={toggleAddSpeaker} />
          </Modal.Body>
        </Modal>

        <Modal
          show={showCreditPurcahseModal !== false}
          onHide={() => {
            setShowCreditPurcahseModal(!showCreditPurcahseModal);
          }}
          size="small"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage id="heading.purchase-credits" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <Button
                variant="primary"
                onClick={() => purchaseCredits(creditsToBePurchased)}
              >
                {`${intl.formatMessage({ id: "purchase.text" })} ${creditsToBePurchased} ${intl.formatMessage({ id: "user.creds" })}${creditsToBePurchased > 1 ? "s" : ""} ${intl.formatMessage({ id: "for.text" })} ${creditsToBePurchased * process.env.REACT_APP_COST_PER_CREDIT} Euros`}
              </Button>
              <br />
              <br />
              <Button
                onClick={() => setShowAccount(!showAccount)}
                variant="default"
              >
                {intl.formatMessage({ id: "link-credit-card" })}
              </Button>
              <ProfileModal
                show={showAccount}
                setShow={(bool) => setShowAccount(bool)}
              />
            </center>
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  schedule: state.schedule,
});

const mapDispatchToProps = (dispatch) => {
  return {
    scheduleItemsFetch: () => dispatch(scheduleItemsFetch()),
    purchaseCredits: (credits) => dispatch(purchaseCredits(credits)),
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AddEditPresentation));
